import { render } from "./Searchbar.vue?vue&type=template&id=f3c47414&ts=true"
import script from "./Searchbar.vue?vue&type=script&lang=ts"
export * from "./Searchbar.vue?vue&type=script&lang=ts"

import "./Searchbar.vue?vue&type=style&index=0&id=f3c47414&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__